import { AsyncHorizontalNavJira } from '@atlassian/jira-horizontal-nav/src/async.tsx';
import { businessProjectLayout } from '@atlassian/jira-business-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarCore from '@atlassian/jira-navigation-apps-sidebar-core/src/async.tsx';
import { ThemedLazySkeleton } from '@atlassian/jira-project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getProjectViewResources } from '@atlassian/jira-router-resources-business-common/src/index.tsx';
import { jiraBusinessTimelineRoute } from '@atlassian/jira-router-routes-business-timeline-routes/src/jiraBusinessTimelineRoute.tsx';
import { timelineEntrypoint as legacyTimelineEntrypoint } from '@atlassian/jira-spa-apps-business-timeline/entrypoint.tsx';
import { timelineEntrypoint } from '@atlassian/jira-spa-apps-harmonised-business-timeline/entrypoint.tsx';
import { jiraHorizontalNavEntrypoint } from '@atlassian/jira-horizontal-nav/entrypoint.tsx';

const timelinePageEntrypoint = createPageEntryPoint({
	main: timelineEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});

const legacyTimelinePageEntrypoint = createPageEntryPoint({
	main: legacyTimelineEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});

export const jiraBusinessTimelineRouteEntry = createEntry(jiraBusinessTimelineRoute, () => ({
	group: 'classic-business',
	ufoName: 'jwm.timeline-view',
	layout: businessProjectLayout,
	skeleton: ThemedLazySkeleton,

	navigation: {
		menuId: MENU_ID.PROJECTS,
		// delete when cleaning up getWillShowNav4
		sidebar: AsyncSidebarCore,
		horizontal: AsyncHorizontalNavJira,
	},

	resources: getProjectViewResources(),

	entryPoint: () =>
		// eslint-disable-next-line jira/ff/no-preconditioning
		fg('jira_timeline_harmonisation_m1_targeting') &&
		fg('issue_table_frozen_columns') &&
		fg('jira_list_merged_column_gate') &&
		fg('jira_timeline_disable_child_inline_editing') &&
		expValEquals('jira_timeline_harmonisation_m1', 'isEnabled', true)
			? timelinePageEntrypoint
			: legacyTimelinePageEntrypoint,

	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-business-timeline-entries/src/jiraBusinessTimelineRouteEntry.tsx',
			whichExportToUse: 'jiraBusinessTimelineRouteEntry',
		},

		enabled: true,
	},
}));
